import Axios, { AxiosInstance } from 'axios';
import { TokenManager } from '../../features/Security/TokenManager';
// const TEMPLATES_BASE_URL = process.env.REACT_APP_TEMPLATE_API_BASE_URL;

let apiNetworkInstance: AxiosInstance;
let apiUnsecuredNetworkInstance: AxiosInstance;

export const createAPIUnsecureNetworkInstance = (): AxiosInstance => {
    if (apiUnsecuredNetworkInstance) {
        // apiNetworkInstance.defaults.headers.common['Authorization'] = createToken();
        return apiUnsecuredNetworkInstance
    }
    apiUnsecuredNetworkInstance = Axios.create({
        baseURL: `${process.env.REACT_APP_LISMA_API_BASE_URL}`//"https://qalismabe.azurewebsites.net/api/"             

    });
    return apiUnsecuredNetworkInstance;
}

export const createAPINetworkInstance = (): AxiosInstance => {
    if (apiNetworkInstance) {
        apiNetworkInstance.defaults.headers.common['Authorization'] = createToken();
        return apiNetworkInstance
    }
    apiNetworkInstance = Axios.create({
        baseURL: `${process.env.REACT_APP_LISMA_API_BASE_URL}`

    });

    apiNetworkInstance.defaults.headers.common['Authorization'] = createToken();
    apiNetworkInstance.interceptors.response.use(responseInterceptorResponse, responseInterceptorError);
    return apiNetworkInstance;
}

const ACCESS_TOKEN_AUTH_TYPE = 'Bearer';

export const createToken = (accessToken?: string) => {
    const bearerToken = accessToken ? accessToken : TokenManager.getInstance().getToken();
    return `${ACCESS_TOKEN_AUTH_TYPE} ${bearerToken}`;
};

const responseInterceptorResponse = (response) => {
    return response;
}

const responseInterceptorError = (error) => {    
    const tokenStorage: TokenManager = TokenManager.getInstance();
    if (error.response.status !== 401) {
        return Promise.reject(error)
    }
    return tokenStorage.getNewToken()
        .then((token) => {
            const config = error.config;
            config.headers['Authorization'] = `Bearer ${token}`;
            return new Promise((resolve, reject) => {
                Axios.request(config).then(response => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                })
            });
        })
        .catch((error) => {
            tokenStorage.clear();
            Promise.reject(error);
        });
}